// TEMPORARY COMPATIBILITY CODE: retained only while legacy WS endpoints are migrated to typed controllers.
// This is not an authoritative API contract; replace it with clients generated from the future server contract.
import { decode, encode, ServiceCodecs } from './wire-contract-runtime';

const service = (operation: string) => {
  const route = operation.slice(operation.indexOf(' ') + 1);
  if (route.startsWith('/billing/')) return 'billing';
  if (route.startsWith('/auth/')) return 'auth';
  if (route.startsWith('/sign/')) return 'sign';
  if (route.startsWith('/payroll/')) return 'payroll';
  if (route.startsWith('/auditlog/')) return 'audit';
  return undefined;
};

export const loadCodecs = async (operation: string): Promise<ServiceCodecs> => {
  switch (service(operation)) {
    case 'auth': return (await import('./wire-contract-auth')).default;
    case 'billing': return (await import('./wire-contract-billing')).default;
    case 'sign': return (await import('./wire-contract-sign')).default;
    case 'payroll': return (await import('./wire-contract-payroll')).default;
    case 'audit': return (await import('./wire-contract-audit')).default;
    default: return {};
  }
};

export const encodeRequest = (codecs: ServiceCodecs, operation: string, value: unknown): unknown => encode(codecs, operation, value);
export const decodeResponse = (codecs: ServiceCodecs, operation: string, value: unknown): unknown => decode(codecs, operation, value);
export const decodeError = (value: unknown): unknown => {
  const decodeOne = (item: unknown) => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return item;
    const source = item as Record<string, unknown>;
    const result = { ...source };
    if ('error_key' in result) { result.errorKey = result.error_key; delete result.error_key; }
    if ('error_message' in result) { result.errorMessage = result.error_message; delete result.error_message; }
    return result;
  };
  return Array.isArray(value) ? value.map(decodeOne) : decodeOne(value);
};
